import { FullStory, init, isInitialized } from "@fullstory/browser";

import environments from "../environments";
import { UserData, Workspace } from "../models";

const initFullStory = () => {
  if (!environments.fullstoryOrgId) return;
  init({ orgId: environments.fullstoryOrgId, devMode: process.env.NODE_ENV !== "production" });
};

const identifyFullStoryUser = (userData: UserData, workspace?: Workspace) => {
  if (!isInitialized() || !userData.id) return;

  FullStory("setIdentity", {
    uid: userData.id,
    properties: {
      displayName: userData?.name ?? "",
      email: userData?.email ?? "",
      teamId: workspace?.id ?? "",
      teamName: workspace?.name ?? "",
    },
  });
};

const updateFullStoryWorkspace = (workspace: Workspace) => {
  if (!isInitialized()) return;
  FullStory("setProperties", {
    type: "user",
    properties: { teamId: workspace.id, teamName: workspace.name },
  });
};

const anonymizeFullStoryUser = () => {
  if (!isInitialized()) return;
  FullStory("setIdentity", { anonymous: true });
};

export { initFullStory, identifyFullStoryUser, updateFullStoryWorkspace, anonymizeFullStoryUser };
